module.exports = __webpack_public_path__ + "img/logos_partner_20.4e734ac5.svg";